export default "__VITE_ASSET__DThaL6UR__"